import { useEffect, useRef, useState } from 'react';

export function useAutoSave(data, saveFn, delay = 2000, enabled = true) {
  const [status, setStatus] = useState('idle'); // idle | saving | saved | error
  const timerRef = useRef(null);
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) { isFirstRender.current = false; return; }
    if (!enabled || !data) return;
    setStatus('saving');
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(async () => {
      try {
        await saveFn(data);
        setStatus('saved');
        setTimeout(() => setStatus('idle'), 2000);
      } catch (err) {
        setStatus('error');
      }
    }, delay);
    return () => clearTimeout(timerRef.current);
  }, [data, saveFn, delay, enabled]);

  return { status, setStatus };
}
